import i18next from "i18next";
export const HUNGARIAN_VAT = 0.27;
export const COUNTRY_CODES_FOR_CALC = {
  Spain: "ES",
  Hungary: "HU",
  UnitedKingdom: "GB",
  France: "FR",
  Germany: "DE",
  Italy: "IT",
  CzechRepublic: "CZ",
  Poland: "PL"
};
export const LEGAL_STATUS = [
  { label: i18next.t("Company"), value: "Company" },
  { label: i18next.t("Partnership"), value: "Partnership" },
  { label: i18next.t("Individual"), value: "Individual" }
];
export const TITLES = [
  { label: i18next.t("Mr"), value: "Mr" },
  { label: i18next.t("Ms"), value: "Ms" }
];
const BUSINESS_TYPES = [
  { label: i18next.t("Marketplace"), value: "Marketplace" },
  { label: i18next.t("Enterprise"), value: "Enterprise" }
];
const AMAZON_BUSINESS_TYPES = [
  { label: i18next.t("Standard"), value: "Marketplace" },
  { label: i18next.t("Premium"), value: "Enterprise" }
];
export const GetBusinessTypes = () => {
  return GetBusinessTypesByClientSource(ClientContext.TenantName);
};
export const GetBusinessTypesByClientSource = (clientSource) => {
  if (clientSource.toLocaleLowerCase() === "amazon") {
    return AMAZON_BUSINESS_TYPES;
  }
  return BUSINESS_TYPES;
};
